// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageGradientOverlay_root__PQlxu","top":"ImageGradientOverlay_top__a6pRD","bottom":"ImageGradientOverlay_bottom__7MlMM"};